/**
 * Task / quote materials use `material.type` from DB; quote-builder catalogs
 * (pipe / fitting / fixing) key rows by large `id` values (e.g. 1010) but many
 * materials store the catalog `order_id` (e.g. 4) or product taxonomy ids.
 * Resolve a human label for dropdowns and keep filter ids aligned with `material.type`.
 */

export function labelForMaterialTypeInCatalog (catalog, typeId, sampleMaterial, allTypesCatalog) {
  if (typeId === null || typeId === undefined || typeId === '') {
    return (sampleMaterial && sampleMaterial.category) ? sampleMaterial.category : 'Other'
  }
  const s = String(typeId)
  const cat = Array.isArray(catalog) ? catalog : []
  const byId = cat.find((c) => String(c.id) === s)
  if (byId && byId.name) return byId.name
  const byOrderStr = cat.find((c) => String(c.order_id) === s)
  if (byOrderStr && byOrderStr.name) return byOrderStr.name
  const n = Number(typeId)
  if (Number.isFinite(n)) {
    const byOrderNum = cat.find((c) => Number(c.order_id) === n)
    if (byOrderNum && byOrderNum.name) return byOrderNum.name
  }
  if (sampleMaterial && sampleMaterial.category) return sampleMaterial.category
  const all = Array.isArray(allTypesCatalog) ? allTypesCatalog : []
  const fromAll = all.find((c) => String(c.id) === s)
  if (fromAll && fromAll.name) return fromAll.name
  return `Type ${typeId}`
}
